/* eslint-disable no-shadow */
const initialState = {
    globalLoader: false,
    contentLoader: false,
    connectionLost: false,
};

const state = () => ({ ...initialState });

const getters = {
    globalLoader: (state) => {
        return state.globalLoader;
    },
    contentLoader: (state) => {
        return state.contentLoader;
    },
    connectionLost: (state) => {
        return state.connectionLost;
    },
};

const actions = {
    setGlobalLoaderVisibility({ commit }, isVisible) {
        commit('setLoader', { type: 'global', active: isVisible });
    },
};

const mutations = {
    setLoader(state, loaderData) {
        state[`${loaderData.type}Loader`] = loaderData.active;
    },
    setConnectionLost(state, connectionLost) {
        state.connectionLost = connectionLost;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
